import styled from "@emotion/styled";
import {
  ASSET_TYPE,
  IMessage,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import {
  ChatContext,
  formatChatMessageTime,
  useGetChatAssets,
} from "hhn-commons";
import { useContext } from "react";
import EmptyRecordView from "../../../../../common/EmptyRecordView";
import ScrollListContainer from "../../../../../common/ScrollListContainer";
import UserImage from "../../../../../common/user/UserImage";
import { UserFullName } from "../../../../../common/user/UserText";
import { DocumentMediaViewerContext } from "../../../../../context/DocumentMediaViewerContext";
import DocumentContent from "../../../../../message/messageType/contentType/DocumentContent";
import theme from "../../../../../theme";

export const DocumentAssetsWrapper = styled(Box)``;
export const DocumentPaper = styled(Paper)`
  margin-bottom: 10px;
  padding: 10px;
  background: ${theme.palette.grey[100]};
`;
export const DocumentItemHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;
const DocumentAssets = () => {
  const { chat } = useContext(ChatContext);

  const { isChatAssetsLoading: isLoading, getChatAssets } = useGetChatAssets(
    ASSET_TYPE.DOCUMENT,
  );
  const { openDocumentMediaViewer } = useContext(DocumentMediaViewerContext);

  const openMediaDialog = (message: IMessage) => {
    openDocumentMediaViewer(message.getPreviewDataFromMessage()!);
  };
  return (
    <ScrollListContainer
      dataTestId="asset-document"
      isLoading={isLoading}
      restTop={115}
      onScrollCallback={getChatAssets}
    >
      <>
        <Box
          sx={{ width: "100%", p: 1, m: 0 }}
          data-testid="asset-document-list"
        >
          {chat?.groupAssets &&
            chat.groupAssets.data.map(data => {
              const message = data.getMessage();
              return (
                <DocumentPaper
                  key={message.id}
                  data-testid="asset-document-list-item"
                >
                  {message.contentType === MESSAGE_CONTENT_TYPE.DOCUMENT &&
                    message.documents &&
                    message.documents.length > 0 && (
                      <DocumentAssetsWrapper>
                        <DocumentItemHeader>
                          <UserImage userId={message.from} />
                          <Box>
                            <UserFullName userId={message.from} />
                            <Typography>
                              {formatChatMessageTime(message.createdAt)}
                            </Typography>
                          </Box>
                        </DocumentItemHeader>
                        <DocumentContent
                          isSender={false}
                          message={data}
                          openMediaDialog={openMediaDialog}
                        />
                      </DocumentAssetsWrapper>
                    )}
                </DocumentPaper>
              );
            })}
          {isLoading && (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "170px",
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>
        {!isLoading &&
          chat?.groupAssets &&
          chat.groupAssets.data.length <= 0 && <EmptyRecordView />}
      </>
    </ScrollListContainer>
  );
};

export default DocumentAssets;
